import { FC, PropsWithChildren } from 'react';
import styles from './style.module.css';

type Props = PropsWithChildren<{
  title: string;
}>;

export const MedicalInstitutionIntroCard: FC<Props> = ({ title, children }) => {
  return (
    <div className={styles.root}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.body}>{children}</div>
    </div>
  );
};
